import { useState } from "react";
import { MapPin, LocateFixed, Loader2 } from "lucide-react";

const dist = (a, b) => Math.hypot(a.lat - b.lat, (a.lng - b.lng) * Math.cos((a.lat * Math.PI) / 180));

export const CityPicker = ({ cities, city, setCity }) => {
  const [state, setState] = useState("");
  const locate = () => {
    if (!navigator.geolocation) return setState("Location not supported on this device");
    setState("loading");
    navigator.geolocation.getCurrentPosition(
      ({ coords }) => {
        const me = { lat: coords.latitude, lng: coords.longitude };
        const near = [...cities].sort((a, b) => dist(me, a) - dist(me, b))[0];
        setCity(near.id);
        setState(`Nearest city: ${near.name}`);
      },
      () => setState("Location permission denied — pick a city below"),
      { timeout: 8000 },
    );
  };
  return (
    <div className="mt-8">
      <button data-testid="re-use-location" onClick={locate} className="inline-flex items-center gap-2 h-11 px-5 rounded-xl bg-[#10B981] hover:bg-[#059669] text-[#0F172A] font-bold transition-colors">
        {state === "loading" ? <Loader2 className="w-4 h-4 animate-spin" /> : <LocateFixed className="w-4 h-4" />} Use my location
      </button>
      {state && state !== "loading" && <span data-testid="re-location-status" className="ml-3 text-sm text-slate-300">{state}</span>}
      <div className="mt-5 flex flex-wrap gap-2">
        {cities.map((c) => (
          <button key={c.id} data-testid={`re-city-${c.id}`} onClick={() => setCity(c.id)}
            className={`inline-flex items-center gap-1.5 h-10 px-4 rounded-full text-sm font-semibold border transition-colors ${city === c.id ? "bg-amber-300 text-[#0F172A] border-amber-300" : "border-white/20 text-slate-200 hover:bg-white/10"}`}>
            <MapPin className="w-3.5 h-3.5" />{c.name}
          </button>
        ))}
      </div>
    </div>
  );
};
